import api from 'api'
import {useMutation} from 'react-query'
import {saveData} from 'utils/saveData'
import {params} from '../commonTypes'

export const useGenerateSoldoutDaysCsvMutation = () => {
  const generate = useMutation(async (params: params.GetReport) => api.generateSoldoutDaysCsv(params), {
    onSuccess({csv, filename}) {
      saveData(csv, filename)
    },
  })

  return generate.mutate
}
